(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('tableauFormationsPreventionRisquesPsychoSociauxCtrl', tableauFormationsPreventionRisquesPsychoSociauxCtrl);

    tableauFormationsPreventionRisquesPsychoSociauxCtrl.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function tableauFormationsPreventionRisquesPsychoSociauxCtrl ($scope, $state, ParseLinks, AlertService) {
        var vm = this;
    }
})();
